import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import type { SettlementChecklistItem } from '../../../utils/settlementFlowConfig';

export function ProbateBackLink({ estateId }: { estateId: string | null }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(estateId ? `/sframe-170/${estateId}` : '/sframe-170')}
      className="flex items-center gap-2 text-stone-500 hover:text-stone-700 mb-6 text-sm"
    >
      <ChevronLeft className="w-4 h-4 shrink-0" aria-hidden />
      Back to Probate Overview
    </button>
  );
}

export function ProbateContextBlock({ point, goal }: { point: string; goal: string }) {
  return (
    <div className="bg-blue-50 rounded-xl p-4 mb-6 text-sm text-stone-700">
      <p>
        <strong>Point:</strong> {point}
      </p>
      <p className="mt-1">
        <strong>Goal:</strong> {goal}
      </p>
    </div>
  );
}

export function ProbateChecklistProgress({ completed, total }: { completed: number; total: number }) {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
  return (
    <div className="mb-4">
      <div className="flex justify-between text-sm text-stone-600 mb-1">
        <span>Progress</span>
        <span>
          {completed} / {total} ({pct}%)
        </span>
      </div>
      <div className="h-2 rounded-full bg-stone-200 overflow-hidden">
        <div className="h-full bg-cyan-600 transition-all duration-300" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export function ProbateChecklistCard({
  items,
  checkedIds,
  toggleItem,
  disabled,
}: {
  items: SettlementChecklistItem[];
  checkedIds: Set<string>;
  toggleItem: (id: string, next: boolean) => void | Promise<void>;
  disabled?: boolean;
}) {
  return (
    <div className="bg-white rounded-xl border border-stone-200 p-5 mb-4 space-y-3">
      {items.map((item) => (
        <div key={item.id} className="flex items-start gap-4">
          <input
            type="checkbox"
            checked={checkedIds.has(item.id)}
            disabled={disabled}
            onChange={() => void toggleItem(item.id, !checkedIds.has(item.id))}
            className="mt-1 h-5 w-5 rounded border-stone-300 text-cyan-600 cursor-pointer disabled:opacity-50"
          />
          <div className="flex-1 min-w-0">
            <p className="font-medium text-stone-800">{item.title}</p>
            {item.description ? <p className="text-stone-500 text-sm mt-1">{item.description}</p> : null}
          </div>
        </div>
      ))}
    </div>
  );
}

export const probateFieldLabelClass = 'block text-sm font-medium text-stone-700 mb-1';
export const probateInputClass =
  'w-full rounded-lg border border-stone-300 px-3 py-2 text-stone-800 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent disabled:bg-stone-100';
